// Smart API URL: uses relative path when on custom domain, 
// falls back to REACT_APP_BACKEND_URL for preview/dev
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const CUSTOM_DOMAIN = 'index24hrs.com';

function getApiUrl() {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // If we're on the custom domain, use relative URLs (same origin)
    if (hostname === CUSTOM_DOMAIN || hostname === `www.${CUSTOM_DOMAIN}`) {
      return '';
    }
  }
  return BACKEND_URL;
}

export const API_URL = getApiUrl();
